import { render, staticRenderFns } from "./SendFormComponent.vue?vue&type=template&id=77d1a272&scoped=true&"
import script from "./SendFormComponent.vue?vue&type=script&lang=js&"
export * from "./SendFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./SendFormComponent.vue?vue&type=style&index=0&id=77d1a272&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d1a272",
  null
  
)

export default component.exports